<form [formGroup]="form">
  <div class="d-flex flex-fill flex-column">
    <div class="d-flex flex-fill flex-column p-20 grey-bkg">
      <app-form-builder-name formControlName="name"></app-form-builder-name>
    </div>
    <div class="d-flex flex-fill flex-column p-20 border-bottom">
      <ey-input [meta]="meta.question" formControlName="question" extra="none" class="mb-20" maxlength="2000"></ey-input>
      <ey-input [meta]="meta.hint" formControlName="hint" extra="none" class="mb-20" maxlength="1000"></ey-input>
      <label class="checkbox checkbox-margin mb-0">
        <input formControlName="required" class="checkbox__input" type="checkbox" (change)="onRequired(form.get('required').value)" />
        <span class="checkbox__checkmark checkbox-background"></span>
        <p class="checkbox__label">Required</p>
        <div *ngIf="requiredFieldCrossValidationError && showError" class="d-flex mt-2 ms-n3">
          <app-form-builder-required-validation-error></app-form-builder-required-validation-error>
        </div>
      </label>
    </div>
    <div class="d-flex flex-fill flex-column p-20 border-bottom">
      <p class="eyfontbold">Settings</p>
      <ey-drop-down
        formControlName="ratingType"
        [meta]="meta.ratingTypes"
        [values]="ratingTypes"
        [defaultValue]="ratingTypes[0]"
        noInfo="true"
        class="mb-20"
      ></ey-drop-down>
      <ey-input formControlName="maxRating" type="number" [meta]="meta.maxRating" extra="none" class="mb-20"></ey-input>
    </div>
  </div>
</form>
